import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { hasAnyPermission, hasPermission } from '../api/auth';

type Props = {
  /** Single required permission */
  permission?: string;
  /** At least one of these permissions */
  anyOf?: string[];
  /** Where to send unauthorized users (default home) */
  redirectTo?: string;
};

/**
 * Route guard for permission codes. Backend remains the source of truth;
 * this blocks deep-link UI for roles without the nav permission.
 */
export function PermissionRoute({ permission, anyOf, redirectTo = '/' }: Props) {
  const allowed =
    (permission ? hasPermission(permission) : false) ||
    (anyOf && anyOf.length > 0 ? hasAnyPermission(anyOf) : false);

  if (!permission && (!anyOf || anyOf.length === 0)) {
    return <Outlet />;
  }

  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}

export default PermissionRoute;
